module.exports = __webpack_public_path__ + "static/media/walmart_image_cn.490cf7ca.png";